import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

import styles from './styles';

class B28Partners1 extends React.Component {
  renderBackground() {
    const { classes } = this.props;
    return (
      <div className={classes.background}>
        <div className={classes.topBlueCurve}></div>
        <div className={classes.bottomBlueCurve}></div>
      </div>
    );
  }

  renderContent() {
    const { classes, data } = this.props;
    const mainTitle = parse(data.blocks.b28partners1.mainTitle);

    return (
      <div className={classes.content}>
        <Typography variant="h1" color="secondary" className={classes.mainTitle}>
          {mainTitle}
        </Typography>
        <div className={classes.main}>
          <div className={classes.desc}>
            <Typography variant="body1" className={classes.bold}>
              {parse(data.blocks.b28partners1.desc)}
            </Typography>
          </div>
          <div className={classes.list}>
            <Typography variant="body2">{parse(data.blocks.b28partners1.list)}</Typography>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.blockContainer}>
        {this.renderBackground()}
        {this.renderContent()}
      </div>
    );
  }
}

B28Partners1.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object,
};

export default withStyles(styles)(B28Partners1);
